const GENERIC_CAR_NAMES = [
  "description not available",
  "determined at pick-up",
  "mystery car",
  "compact or larger",
];

const stripHtmlTags = (text: string): string =>
  text.replace(/<[^>]*>/g, "");

const stripOrSimilar = (name: string): string =>
  name.replace(/\s+or\s+similar\s*$/i, "").trim();

export const shouldAddOrSimilar = (name: string): boolean => {
  const stripped = stripHtmlTags(name);
  if (/\s+or\s+similar\s*$/i.test(stripped)) {
    return true;
  }
  const normalized = stripped.toLowerCase().trim();
  if (GENERIC_CAR_NAMES.some((pattern) => normalized.includes(pattern))) {
    return false;
  }
  return !/\bor\b/i.test(stripped);
};

export const normalizeVehicleName = (name: string): string =>
  stripOrSimilar(stripHtmlTags(name));

export const DEFAULT_CAR_DETAILS_TEXT = {
  orText: "or",
  orSimilarText: "or similar",
  unlimitedMileageText: "Unlimited mileage",
  freeCancellationText: "Free cancellation",
  nonRefundableText: "Non refundable",
  selectButtonText: "Select",
};

export const getCarDetailsText = (vehicleName: string) => ({
  ...DEFAULT_CAR_DETAILS_TEXT,
  orSimilarText: shouldAddOrSimilar(vehicleName) ? "or similar" : "",
});
